import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Row, Col, Card, CardBody } from 'reactstrap';
import renderSelectField from 'src/shared/components/form/Select';
import { connect } from 'react-redux';
import EyeIcon from 'mdi-react/EyeIcon'; // Keep using mdi-react for eye icon to match existing or switch if desired
import renderToggleButtonField from 'src/shared/components/form/ToggleButton';
import { ITC_ADMIN_ROLE_ID, CLIENT_ADMIN, ERROR_MESSAGES, } from '../../../../../utils/pnd/PndConstants';
import PndApi from '../../../../../utils/pnd/PndRestApi';
import { showNotification } from 'src/shared/components/Notification';
import { isNumber, validateUaeLandline } from 'src/utils/validationUtils';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import BusinessIcon from '@mui/icons-material/Business';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import SaveIcon from '@mui/icons-material/Save';
import CallIcon from '@mui/icons-material/Call';


const required = value => value ? undefined : 'Required'

// Compact Input Field Renderer (Simulating Driver Details style)
const renderCompactField = ({ input, placeholder, type, meta: { touched, error, warning }, disabled, icon: Icon }) => (
  <div>
    <div className={`input-group input-group-sm ${touched && error ? 'has-validation' : ''}`}>
      {Icon && (
        <span className="input-group-text bg-light border-end-0 text-muted" style={{ padding: '0.25rem 0.5rem' }}>
          <Icon style={{ fontSize: '1rem' }} />
        </span>
      )}
      <input
        {...input}
        className={`form-control form-control-sm ${touched && error ? 'is-invalid' : ''} ${Icon ? 'border-start-0' : ''}`}
        placeholder={placeholder}
        type={type}
        disabled={disabled}
        style={{ fontSize: '0.85rem' }}
      />
      {touched && ((error && <div className="invalid-feedback">{error}</div>) || (warning && <div className="text-warning small">{warning}</div>))}
    </div>
  </div>
);

const valueLength = (value) => value && value.length !== 12 ? ` must be 12 Digits` : undefined;
const startWithHash = (value) =>
  value &&
    (value[0] !== `9` || value[1] !== `7` || value[2] !== `1` || value[3] !== `5`)
    ? `Mobile No. will start with 9715`
    : undefined;
const emailErrorRequired = (value) => value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? undefined : `Please enter a valid Email Id`;
const userNameValidation = (value) => {
  if (!value) return undefined;

  // Check for minimum length (at least 6 characters)
  if (value.length < 6) {
    return '- should contain at least 6 characters.';
  }

  // Check for allowed characters (alphabetic and numeric)
  const alphaNumericRegex = /^[a-zA-Z0-9]*$/;
  if (!alphaNumericRegex.test(value)) {
    return '- User Name should contain only alphabetic and numeric characters. Special characters are not allowed.';
  }

  return undefined;
};


const AuthCreation = ({ handleSubmit, userData, status }) => {
  const userType = localStorage.getItem("ut");
  useEffect(() => {
    if (userType == ITC_ADMIN_ROLE_ID) {
      getAllInformapClient();
    } else {
      GetAllActiveHubDetails();
    }

  }, [])
  const [showPassword, setShowPassword] = useState(false);
  const [isClientInfo, setClientInfo] = useState([]);
  const [isActiveHubList, setActiveHubList] = useState(null);
  const [isHubDiv, setHubDiv] = useState(false); // Kept for logic, though unused in render currently

  const showPasswordToggle = () => {
    setShowPassword(!showPassword);
  };
  const GetAllActiveHubDetails = async () => {
    let activeHub = [];
    try {
      const response1 = await PndApi.GetAllActiveHub().catch(error => {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response1?.data?.status}`,
          `Message: ${response1?.data?.message}`,
        );
      })

      if (response1 && response1.status === 200 && response1.data.status === 200) {
        if (response1.data.data.length > 0) {
          response1.data.data.map(item => {
            activeHub.push({ "label": item.hubName, "value": item.hubId });
          })
          setActiveHubList(activeHub);
        }

      } else if (response1.data.status === 204) {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response1?.data?.status}`,
          `Message: Hub is not created for this client. Please create Hub first`,
        );
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    }
  }

  const getAllInformapClient = async () => {
    try {
      var clientInfoList = [];
      console.log("getAllInformapClient");
      const response = await PndApi.GetAllInformapClientForAdminCreation();
      if (response.status === 200 && response.data.status === 200) {
        response.data.data.map(item => {
          clientInfoList.push({ "label": item.clientName, "value": item.customerId });
        })
        setClientInfo(clientInfoList);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
    }

  };

  const hideHubDiv = (event) => {
    if (event) {
      if (event.value !== ITC_ADMIN_ROLE_ID || event.value !== CLIENT_ADMIN) {
        setHubDiv(true);
      } else {
        setHubDiv(false);
      }
    }
  }

  return (
    <>
      <form className="form-animated p-2 bg-light" onSubmit={handleSubmit}>

        {/* Account Details Section */}
        <Card className="border-0 shadow-sm mb-2">
          <CardBody className="p-2">
            <div className="d-flex align-items-center mb-2 text-primary border-bottom pb-1">
              <BusinessIcon style={{ fontSize: '1.2rem' }} className="me-2" />
              <h6 className="m-0 fw-bold small text-uppercase">Account Details</h6>
            </div>
            <Row className="g-2">
              {userType == ITC_ADMIN_ROLE_ID &&
                <>
                  <Col md={6}>
                    <div className="mb-1">
                      <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Account Type <span className='text-danger'>*</span></label>
                      <Field
                        validate={[required]}
                        name="roleId"
                        component={renderSelectField}
                        type="text"
                        options={[{ value: 2, label: "Client Admin" }]}
                        placeholder="Select Account Type"
                        onChange={hideHubDiv}
                        className="form-control-sm"
                        isDisabled={!!userData}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-1">
                      <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Client Name <span className='text-danger'>*</span></label>
                      <Field
                        validate={[required]}
                        name="customerId"
                        component={renderSelectField}
                        options={isClientInfo}
                        placeholder="Select Client"
                        className="form-control-sm"
                      />
                    </div>
                  </Col>
                </>
              }
              {userType == CLIENT_ADMIN &&
                <>
                  <Col md={6}>
                    <div className="mb-1">
                      <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Account Type <span className='text-danger'>*</span></label>
                      <Field
                        validate={[required]}
                        name="roleId"
                        component={renderSelectField}
                        options={[
                          { value: 4, label: "Hub Manager" },
                          { value: 3, label: "Hub Operator" },
                          { value: 7, label: "Security" },
                        ]}
                        placeholder="Select Account Type"
                        onChange={hideHubDiv}
                        className="form-control-sm"
                        isDisabled={!!userData}
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="mb-1">
                      <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Primary Hub <span className='text-danger'>*</span></label>
                      <Field
                        validate={[required]}
                        name="hub"
                        component={renderSelectField}
                        options={isActiveHubList}
                        placeholder="Select Hub"
                        onChange={event => hideHubDiv(event, 1)}
                        className="form-control-sm"
                        isDisabled={!!userData}
                      />
                    </div>
                  </Col>
                </>
              }
            </Row>
          </CardBody>
        </Card>

        {/* Personal Details Section */}
        <Card className="border-0 shadow-sm mb-2">
          <CardBody className="p-2">
            <div className="d-flex align-items-center mb-2 text-primary border-bottom pb-1">
              <PersonIcon style={{ fontSize: '1.2rem' }} className="me-2" />
              <h6 className="m-0 fw-bold small text-uppercase">Personal Details</h6>
            </div>
            <Row className="g-2">
              <Col md={6}>
                <div className="mb-1">
                  <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Full Name <span className='text-danger'>*</span></label>
                  <Field
                    validate={required}
                    component={renderCompactField}
                    name="fullName"
                    type="text"
                    placeholder="Enter Full Name"
                    icon={PersonIcon}
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="mb-1">
                  <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>User Name <span className='text-danger'>*</span></label>
                  <Field
                    validate={[required, userNameValidation]}
                    component={renderCompactField}
                    name="userName"
                    type="text"
                    placeholder="Enter Username"
                    disabled={!!userData}
                    icon={AccountCircleIcon}
                  />
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* Contact Information */}
        <Card className="border-0 shadow-sm mb-2">
          <CardBody className="p-2">
            <div className="d-flex align-items-center mb-2 text-primary border-bottom pb-1">
              <PhoneIcon style={{ fontSize: '1.2rem' }} className="me-2" />
              <h6 className="m-0 fw-bold small text-uppercase">Contact Info</h6>
            </div>
            <Row className="g-2">
              <Col md={4}>
                <div className="mb-1">
                  <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Mobile Number <span className='text-danger'>*</span></label>
                  <Field
                    validate={[required, startWithHash, valueLength]}
                    component={renderCompactField}
                    name="mobileNo"
                    type="text"
                    placeholder="9715xxxxxxxx"
                    icon={PhoneIcon}
                  />
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-1">
                  <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Landline No.</label>
                  <Field
                    component={renderCompactField}
                    name="phoneNo"
                    validate={[isNumber, validateUaeLandline]}
                    type="text"
                    placeholder="04xxxxxxx"
                    icon={CallIcon}
                  />
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-1">
                  <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Email Address <span className='text-danger'>*</span></label>
                  <Field
                    validate={[required, emailErrorRequired]}
                    component={renderCompactField}
                    name="emailId"
                    type="text"
                    placeholder="example@mail.com"
                    icon={EmailIcon}
                  />
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>

        {/* Security & Status - Only for New Users */}
        {!userData &&
          <Card className="border-0 shadow-sm mb-2">
            <CardBody className="p-2">
              <div className="d-flex align-items-center mb-2 text-primary border-bottom pb-1">
                <LockIcon style={{ fontSize: '1.2rem' }} className="me-2" />
                <h6 className="m-0 fw-bold small text-uppercase">Security</h6>
              </div>
              <Row className="g-2">
                <Col md={6}>
                  <div className="mb-1">
                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Password <span className='text-danger'>*</span></label>
                    <div className="input-group input-group-sm">
                      <span className="input-group-text bg-light border-end-0 text-muted"><LockIcon style={{ fontSize: '1rem' }} /></span>
                      <Field
                        validate={required}
                        name="password"
                        component="input"
                        type={showPassword ? 'text' : 'password'}
                        className="form-control form-control-sm border-start-0 border-end-0"
                        placeholder="Password"
                      />
                      <button
                        className="btn btn-outline-secondary border-start-0"
                        type="button"
                        onClick={showPasswordToggle}
                        style={{ padding: '0 6px', lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', height: 40, width: 34 }}
                      >
                        <EyeIcon size={14} />
                      </button>
                    </div>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-1">
                    <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem' }}>Confirm Password <span className='text-danger'>*</span></label>
                    <div className="input-group input-group-sm">
                      <span className="input-group-text bg-light border-end-0 text-muted"><LockIcon style={{ fontSize: '1rem' }} /></span>
                      <Field
                        validate={required}
                        name="confirmPassword"
                        component="input"
                        type={showPassword ? 'text' : 'password'}
                        className="form-control form-control-sm border-start-0 border-end-0"
                        placeholder="Confirm Password"
                      />
                      <button
                        className="btn btn-outline-secondary border-start-0"
                        type="button"
                        onClick={showPasswordToggle}
                        style={{ padding: '0 6px', lineHeight: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', height: 40, width: 34 }}
                      >
                        <EyeIcon size={14} />
                      </button>
                    </div>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        }

        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '24px', marginTop: '16px' }}>
          <div className="d-flex align-items-center gap-2">
            <label className="form-label fw-bold text-muted small mb-0" style={{ fontSize: '0.75rem', whiteSpace: 'nowrap' }}>ACTIVE STATUS</label>
            <Field
              name="active"
              component={renderToggleButtonField}
              defaultChecked={status}
            />
          </div>
          <Button
            color="primary"
            type="submit"
            size="sm"
            className="px-4 py-1 rounded-pill shadow-sm d-flex align-items-center"
            style={{ background: 'linear-gradient(90deg, #00C9FF 0%, #92FE9D 100%)', border: 'none', color: '#000', fontWeight: 'bold', fontSize: '0.85rem' }}
            onClick={handleSubmit}
          >
            <SaveIcon style={{ fontSize: '1rem' }} className="me-1" />
            Submit
          </Button>
        </div>
      </form>

    </>
  );
};

AuthCreation.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = (state, data) => {
  if (data && data?.userData) {
    return {
      initialValues: {
        userId: data?.userData?.userId,
        userName: data?.userData?.userName,
        fullName: data?.userData?.fullName,
        emailId: data?.userData?.emailId,
        mobileNo: data?.userData?.mobileNo,
        phoneNo: data?.userData?.phoneNo,
        active: data?.userData?.active == 1 ? true : false,
        roleId: data?.userData?.userRoleInfo ? { "label": data?.userData?.userRoleInfo?.name, "value": data?.userData?.userRoleInfo?.roleId } : { "label": data?.userData?.roleName, "value": data?.userData?.roleId },
        customerId: { "label": data?.userData?.customerInfo?.clientName, "value": data?.userData?.customerInfo?.customerId },
        hub: { "label": data?.userData?.hubName, "value": data?.userData?.hubId },
      }
    }

  }
}

export default connect(mapStateToProps)(reduxForm({ form: 'authCreationForm', enableReinitialize: true })(AuthCreation))
